namespace Solovis.Reports.Parameters {
  // TODO: should be rewritten, so instance of this class won't be created for every tagSet parameter'
  export class TagSetParameterControl extends Solovis.UI.BaseControl {
    private _portalServices: Solovis.Portal.IPortalServices;

    public static hasNewRender = true;
    public parameterList;
    public parameterSet;

    public settings;

    public initialParameterValue;
    public currentTagSet;

    public _exposureProfileParam;

    public selectedTagSetLabel;
    public selectTagSetLink;

    public _selectionDialog;

    private tagSets;
    private _selectRef;

    constructor(options, info) {
      super(options, info);

      this._portalServices = options.portalServices;

      this.parameterList = options.parameterList;
      if (this.parameterList) {
        this.parameterSet = this.parameterList.parameterSet;
      }

      this.settings = options.settings ? options.settings : {};

      this.initialParameterValue =
        typeof options.initialValue != "undefined"
          ? options.initialValue
          : false;
      this.currentTagSet = this.initialParameterValue;

      // If _exposureProfileParam is set, we will limit the allowed tag sets to the ones specified on the exposure profile.
      this._exposureProfileParam = null;
      if (this.settings.dependsOn) {
        this._exposureProfileParam = this.settings.dependsOn.exposureProfile
          ? this.settings.dependsOn.exposureProfile
          : null;
      }
    }
    private async _getTagSetOptions(profileId, portalServices) {
      var filterOptions = { profileId };
      let tagSetList = [];

      await portalServices
        .rpc()
        .invokeAndWait(
          "~/DataManagement/ExposureProfileEditor/GetExposureProfile",
          filterOptions,
          function (response, success) {
            if (success) {
              const { tagSetIds, code } = response.result;
              tagSetList = tagSetIds.map((tagSetId: number) => ({
                code,
                tagSetId,
              }));
            }
          }
        );
      return tagSetList;
    }

    private addDependencySubscription = () => {
      if (
        this._exposureProfileParam &&
        this.parameterList &&
        this.parameterList.parameterSet
      ) {
        const parameterSetControl = this.parameterList.parameterSet;
        parameterSetControl.listenForParameterChange({
          paramName: this._exposureProfileParam,
          subscriptionHandler: this.updateTagSetOption,
          unmountHandler: this.unsubscribeCallback,
          shouldUnmount: Boolean(this.info.list),
        });
      }
    };

    private unsubscribeCallback = () => {
      if (this._selectionDialog) {
        this._selectionDialog.close();
        this._selectionDialog = null;
      }
    };

    private updateTagSetOption = async (profileHolder) => {
      if (this.parameterSet && profileHolder.id) {
        // if this class is a list element, only first instance of this class handles updated tagSetOptions
        if (
          this.info.list &&
          this.controlHost.container.parent().index() !== 0
        ) {
          return;
        }
        const tagSetOptions = await this._getTagSetOptions(
          profileHolder.id,
          this._portalServices
        );
        this.parameterSet.setParameterValue(
          this.info.name,
          this.info.list ? tagSetOptions : tagSetOptions[0]
        );
      }
    };

    public static preload(
      newValue,
      callback,
      portalServices: Solovis.Portal.IPortalServices
    ) {
      if (newValue && (newValue.tagSetId || newValue.code)) {
        let tagSetRequest: any = {};
        if (newValue.tagSetId) tagSetRequest.tagSetId = newValue.tagSetId;
        else if (newValue.code) tagSetRequest.tagSetCode = newValue.code;

        portalServices
          .rpc()
          .invoke(
            "~/Selectors/TagSelector/GetTagSetData",
            tagSetRequest,
            function (response, success) {
              if (success) {
                var tagSetData = response.result;
                callback(tagSetData, true);
              } else {
                callback(null, false);
              }
            }
          );
      } else {
        callback(null, true);
      }
    }

    public static serializeParameterValue(value): any {
      if (value) {
        if (value.tagSetId) {
          return { tagSetId: value.tagSetId };
        } else if (value.code) {
          return { code: value.code };
        }
      }

      return null;
    }

    public static getLabel(value): string | undefined {
      return value?.label;
    }

    public doRender() {
      if (this.options.renderMode === "modern") {
        this.doRenderNew();
      } else {
        this.doRenderClassic();
      }

      this.addDependencySubscription();
    }

    public doRenderClassic() {
      var self = this;

      this.selectedTagSetLabel = $("<a>").appendTo(this.container);

        Solovis.UI.PopupLinkPanel.onElementClick(
          this.selectedTagSetLabel,
          function (e) {
            if (self.currentTagSet && self.currentTagSet.tagSetId) {
              Solovis.UI.PopupLinkPanel.showLinks({
                offset: { left: e.pageX, top: e.pageY },
                links: self._portalServices
                  .reportLinker()
                  .getTagSetLinks(self.currentTagSet),
              });
            }
          }
        );

        this.selectTagSetLink = $("<a>")
          .html("<span class='fa fa-pencil'></span>")
          .appendTo(this.container);

        this.selectTagSetLink.click(function () {
          self._toggleSelectorDialog(function (tagSet) {
            self._setCurrentTagSetData(tagSet);
            self.notifyParameterValueChanged();
          });
        });
        // Set initial parameter value text.
        if (this.currentTagSet) {
          this._setCurrentTagSetData(this.currentTagSet);
        }
    }

    private async doRenderNew() {
      var self = this;

      const { fetchTagSets } = await (window as any).importShim(
        "@solovis/pa-utils"
      );
      const target = this.container[0];
      await Solovis.UX.Utils.placeComponent("AsyncSelect", target, {
        cacheOptions: self._exposureProfileParam === null, // remove caching to allow new results if exposure profile changes
        filterOption: (option, input) => {
          return (
            (TagSetParameterControl.getLabel(option) as string)
              .toLowerCase()
              .indexOf(input.toLowerCase()) > -1
          );
        },
        defaultValue: (self.options as any).initialValue || undefined,
        getOptionLabel: TagSetParameterControl.getLabel,
        getOptionValue: (option) => option.resourceId + "",
        loadOptions: () =>
          new Promise(async (resolve, reject) => {
            try {
              const filter: any = {};
              if (self._exposureProfileParam && self.parameterSet) {
                var exposureProfile = self.parameterSet.getParameterValue(
                  self._exposureProfileParam
                );
                if (exposureProfile) {
                  filter.exposureProfileId = exposureProfile.id;
                }
              }
              const options = await fetchTagSets(filter);
              self.tagSets = options;
              resolve(options);
            } catch (e) {
              reject(e);
            }
          }),
        onChange: (selectedItem) => {
          this.currentTagSet = selectedItem;
          self.notifyParameterValueChanged();
        },
        ref: (ref) => {
          self._selectRef = ref;
        },
      });
    }

    public _setCurrentTagSetData(tagSetData) {
      this.currentTagSet = tagSetData;
      if (this.options.renderMode === "classic") {
        this.selectedTagSetLabel.text(
          this.currentTagSet ? TagSetParameterControl.getLabel(this.currentTagSet) + " " : ""
        );
      } else {
        this._selectRef.setValue(tagSetData);
      }
    }

    public setParameterValue(newValue, more) {
      Solovis.Reports.Parameters.ParameterControlHelper.handleSetParameterValue(
        this,
        TagSetParameterControl,
        this._setCurrentTagSetData,
        newValue,
        more,
        this._portalServices
      );
    }

    public getParameterValue() {
      if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
        return this.initialParameterValue ? this.initialParameterValue : null;
      } else if (this.currentTagSet) {
        return Solovis.deepCopy(this.currentTagSet);
      } else {
        return null;
      }
    }

    public notifyParameterValueChanged() {
      $(this).trigger("parameterValueChanged");
    }

    public _toggleSelectorDialog(selectionCallback) {
      var self = this;

      if (this._selectionDialog) {
        // We already have the selection dialog open, so close it.
        this._selectionDialog.close();
        this._selectionDialog = null;
        return;
      }

      var filter: any = {};
      if (this._exposureProfileParam && this.parameterSet) {
        var exposureProfile = this.parameterSet.getParameterValue(
          this._exposureProfileParam
        );
        if (exposureProfile) {
          filter.exposureProfileId = exposureProfile.id;
        }
      }

      var selectorControlHostDiv = $("<div>");
      var selectorControlHost = new Solovis.UI.ControlHost({
        container: selectorControlHostDiv,
      });
      var selectorControl = new Solovis.InvDataSelectors.TagSetSelectorControl({
        controlHost: selectorControlHostDiv,
        portalServices: this._portalServices,
        initialValue: this.currentTagSet,

        filter: filter,

        selectionCallback: function (tagSet) {
          selectionCallback(tagSet);
          self._selectionDialog.close();
        },
        cancelCallback: function () {
          self._selectionDialog.close();
        },
      });
      selectorControlHost.setCurrentControl(selectorControl);

      // Determine dialog position.
      var linkOffset = $(this.selectedTagSetLabel).offset();
      var linkHeight = $(this.selectTagSetLink).outerHeight();
      var dialogPosition = {
        left: linkOffset.left,
        top: linkOffset.top + linkHeight + 5,
      };

      var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(
        dialogPosition,
        { width: 350, height: 150 }
      );

      var desiredWidth = Math.min($(window).width() * 0.8, 250);
      var desiredHeight = Math.min($(window).height() * 0.8, 300);

      var minWidth = 100;
      var minHeight = 100;

      this._selectionDialog = new Solovis.UI.Dialog({
        container: selectorControlHostDiv,
        ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

        title: false,
        autoOpen: true,
        destroyOnClose: true,
        actions: ["Close"],
        noAnimation: true,
        position: adjustedPosition,
        width: desiredWidth,
        height: desiredHeight,
        minHeight: minHeight,
        minWidth: minWidth,

        buttons: [
          {
            label: "Clear",
            click: function () {
              selectionCallback(null);
              self._selectionDialog.close();
            },
          },
          {
            label: "Cancel",
            click: function () {
              self._selectionDialog.close();
            },
          },
        ],

        activate: function () {
          var overallHeight = this.getAvailableContentHeight();
          selectorControl.setAvailableHeight(overallHeight);
        },

        resize: function () {
          var overallHeight = this.getAvailableContentHeight();
          selectorControl.setAvailableHeight(overallHeight);
        },

        deactivate: function () {
          self._selectionDialog = null;
        },
      });
    }
  }
}
